import React from 'react';
import { LoadingState } from '../common/ui/PagePrimitives';
export default function PageLoader() { return <LoadingState />; }
